import equalByNameAndPaymentParametersId from '../../utils/equalByNameAndPaymentParametersId';
import dateConverter from '../../../../utils/converters/date.converter';
import {i18n} from "../../../vue-i18n";

export default class ChangePaymentStartDate {
  constructor(paymentParametersId, newStartDate) {
    this.commandName = "ChangePaymentStartDate";

    this.paymentParametersId = paymentParametersId;
    this.newStartDate = newStartDate;

    const convertedDate = dateConverter.convertToDate(newStartDate);

    this.description =
      `${i18n.t('CONTENT.events.new_startDate')}: ${i18n.d(convertedDate)}`;
  }

  // Use this method to push this command to the server
  serialize() {
    return {
      commandName: this.commandName,
      serialisedCommand: JSON.stringify({
        PaymentParametersId: this.paymentParametersId,
        NewStartDate: this.newStartDate
      })
    }
  }

  equal = (other) => equalByNameAndPaymentParametersId(this, other);
}
